class PriceRangeSelector extends HTMLElement {
  constructor() {
    super();

    this.range_inputs = document.querySelectorAll(".range-input");
    this.price_inputs = document.querySelectorAll(".price-input");
    this.range = document.querySelector(".slider .progress");

    this.min = 0;
    this.max = this.price_inputs[1].max;
    this.price_gap = Math.round(this.max / 9);

    this.onRangeInput = this.onRangeInput.bind(this);

    this.range_inputs.forEach((element) =>
      element.addEventListener("input", this.onRangeInput.bind(this))
    );

    this.onPriceInput = this.onPriceInput.bind(this);

    // this.debouncedOnInput = debounce((event) => {
    //   this.onPriceInput(event);
    // }, 3000);

    this.price_inputs.forEach((element) => {
      // element.addEventListener('input', this.debouncedOnInput.bind(this))
      element.addEventListener("change", this.onPriceInput.bind(this));
    });
  }

  connectedCallback() {
    this.range.style.left = (this.price_inputs[0].value / this.max) * 100 + "%";
    this.range.style.right =
      100 - (this.price_inputs[1].value / this.max) * 100 + "%";
  }

  onRangeInput(e) {
    let min_val = Math.round(this.range_inputs[0].value),
      max_val = Math.round(this.range_inputs[1].value);

    if (max_val - min_val < this.price_gap) {
      if (e.target.classList.contains("range-min")) {
        this.range_inputs[0].value = max_val - this.price_gap;
      } else if (e.target.classList.contains("range-max")) {
        this.range_inputs[1].value = min_val + this.price_gap;
      }
    } else {
      this.price_inputs[0].value = min_val;
      this.price_inputs[0].dispatchEvent(new Event("change"));
      this.price_inputs[1].value = max_val;
      this.price_inputs[1].dispatchEvent(new Event("change"));

      this.range.style.left = (min_val / this.range_inputs[0].max) * 100 + "%";
      this.range.style.right =
        100 - (max_val / this.range_inputs[1].max) * 100 + "%";
    }
  }

  onPriceInput(e) {
    let min_price = parseInt(this.price_inputs[0].value),
      max_price = parseInt(this.price_inputs[1].value);

    if (e.target.classList.contains("input-min")) {
      if (min_price < this.min) {
        this.price_inputs[0].value = this.min;
      } else if (max_price - min_price < this.price_gap) {
        this.price_inputs[0].value = max_price - this.price_gap;
      } else {
        this.range_inputs[0].value = min_price;
        this.range.style.left =
          (min_price / this.range_inputs[0].max) * 100 + "%";
      }
    }

    if (e.target.classList.contains("input-max")) {
      if (max_price > this.max) {
        this.price_inputs[1].value = this.max;
      } else if (max_price - min_price < this.price_gap) {
        this.price_inputs[1].value = min_price + this.price_gap;
      } else {
        this.range_inputs[1].value = max_price;
        this.range.style.right =
          100 - (max_price / this.range_inputs[1].max) * 100 + "%";
      }
    }
  }
}

customElements.define("price-range-selector", PriceRangeSelector);

document.addEventListener("click", function (event) {
  const popup = document.querySelector(".marketplace-popup.show");

  if (
    !event.target.closest(".marketplace-shipping-info") &&
    !event.target.closest(".marketplace-popup") &&
    !event.target.closest(".quantity-selector__wrapper") &&
    popup
  ) {
    closePopup(event, popup);
  }
});

// document.addEventListener("keydown", function (event) {
//   const popup = document.querySelector(".marketplace-popup.show");

//   if (event.key === "Escape" && popup) {
//     closePopup(event, popup);
//   }
// });

function openPopup(target) {

  const popup = target
    .closest("quantity-selector")
    .querySelector(".marketplace-popup");

  if (popup.style.display === "block") {
    // popup.classList.remove("show");
    // setTimeout(() => (popup.style.display = "none"), 300);
  } else {
    popup.style.display = "block";
    setTimeout(() => popup.classList.add("show"), 10);
  }
}

function closePopup(event, popup) {
  event.stopPropagation();

  const popupElement =
    popup ||
    event.currentTarget
      .closest(".marketplace-shipping-info-wrap")
      .querySelector(".marketplace-popup");

  popupElement.classList.remove("show");
  setTimeout(() => (popupElement.style.display = "none"), 300);
}